/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React from "react";
import { Helmet } from "react-helmet";
export interface ICustomMetaTagsProps {
  title?: string;
  description?: string;
  favicon?: string;
}

export const CustomMetaTags = (props: ICustomMetaTagsProps) => {
  const { title, description, favicon } = props;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="icon" type="image/png" href={favicon} sizes="16x16" />
    </Helmet>
  );
};

CustomMetaTags.defaultProps = {
  title: "Site title",
  description: "Site  Description",
};
